const e = {
  "cdr-tab-panel": "cdr-tab-panel_13-5-2",
  "cdr-tab-panel-enter-left": "cdr-tab-panel-enter-left_13-5-2",
  "cdr-tab-panel-enter-right": "cdr-tab-panel-enter-right_13-5-2",
  "cdr-tab-panel-exit-left": "cdr-tab-panel-exit-left_13-5-2",
  "cdr-tab-panel-exit-right": "cdr-tab-panel-exit-right_13-5-2",
  "cdr-tabs": "cdr-tabs_13-5-2",
  "cdr-tabs__header-container": "cdr-tabs__header-container_13-5-2",
  "cdr-tabs__header": "cdr-tabs__header_13-5-2",
  "cdr-tabs__header-item": "cdr-tabs__header-item_13-5-2",
  "cdr-tabs__header-item-active": "cdr-tabs__header-item-active_13-5-2",
  "cdr-tabs__header-item--disabled": "cdr-tabs__header-item--disabled_13-5-2",
  "cdr-tabs__gradient-container": "cdr-tabs__gradient-container_13-5-2",
  "cdr-tabs__gradient": "cdr-tabs__gradient_13-5-2",
  "cdr-tabs__gradient--left": "cdr-tabs__gradient--left_13-5-2",
  "cdr-tabs__gradient--right": "cdr-tabs__gradient--right_13-5-2",
  "cdr-tabs__gradient--active": "cdr-tabs__gradient--active_13-5-2",
  "cdr-tabs__underline": "cdr-tabs__underline_13-5-2",
  "cdr-tabs__content-container": "cdr-tabs__content-container_13-5-2",
  "fade-enter-active": "fade-enter-active_13-5-2",
  "fade-leave-active": "fade-leave-active_13-5-2",
  "fade-enter": "fade-enter_13-5-2",
  "fade-leave-to": "fade-leave-to_13-5-2",
  "cdr-tabs--compact": "cdr-tabs--compact_13-5-2",
  "cdr-tabs__header-item-label": "cdr-tabs__header-item-label_13-5-2",
  "cdr-tabs--small": "cdr-tabs--small_13-5-2",
  "cdr-tabs--no-border": "cdr-tabs--no-border_13-5-2",
  "cdr-tabs--full-width": "cdr-tabs--full-width_13-5-2",
  "cdr-tabs--centered": "cdr-tabs--centered_13-5-2"
};
export {
  e as default
};
